import React from 'react';
import { AlertCircle, X, Settings, RefreshCw, MapPin, Truck } from 'lucide-react';
import { Button } from './ui';

const ErrorModal = ({ isOpen, onClose, title, message, type = 'error' }) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'configuration':
        return <Settings className="w-8 h-8 text-orange-500" />;
      case 'route_unavailable':
        return <MapPin className="w-8 h-8 text-blue-500" />;
      case 'carrier_not_configured':
        return <Truck className="w-8 h-8 text-purple-500" />;
      case 'relay_carrier_not_configured':
        return <Truck className="w-8 h-8 text-indigo-500" />;
      case 'warning':
        return <AlertCircle className="w-8 h-8 text-yellow-500" />;
      default:
        return <AlertCircle className="w-8 h-8 text-red-500" />;
    }
  };

  const getColorClasses = () => {
    switch (type) {
      case 'configuration':
        return {
          bg: 'bg-orange-50 dark:bg-orange-900/20',
          border: 'border-orange-200 dark:border-orange-800',
          text: 'text-orange-800 dark:text-orange-200',
          button: 'bg-orange-600 hover:bg-orange-700'
        };
      case 'route_unavailable':
        return {
          bg: 'bg-blue-50 dark:bg-blue-900/20',
          border: 'border-blue-200 dark:border-blue-800',
          text: 'text-blue-800 dark:text-blue-200',
          button: 'bg-blue-600 hover:bg-blue-700'
        };
      case 'carrier_not_configured':
        return {
          bg: 'bg-purple-50 dark:bg-purple-900/20',
          border: 'border-purple-200 dark:border-purple-800',
          text: 'text-purple-800 dark:text-purple-200',
          button: 'bg-purple-600 hover:bg-purple-700'
        };
      case 'relay_carrier_not_configured':
        return {
          bg: 'bg-indigo-50 dark:bg-indigo-900/20',
          border: 'border-indigo-200 dark:border-indigo-800',
          text: 'text-indigo-800 dark:text-indigo-200',
          button: 'bg-indigo-600 hover:bg-indigo-700'
        };
      case 'warning':
        return {
          bg: 'bg-yellow-50 dark:bg-yellow-900/20',
          border: 'border-yellow-200 dark:border-yellow-800',
          text: 'text-yellow-800 dark:text-yellow-200',
          button: 'bg-yellow-600 hover:bg-yellow-700'
        };
      default:
        return {
          bg: 'bg-red-50 dark:bg-red-900/20',
          border: 'border-red-200 dark:border-red-800',
          text: 'text-red-800 dark:text-red-200',
          button: 'bg-red-600 hover:bg-red-700'
        };
    }
  };

  const colors = getColorClasses();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-fade-in">
      <div className={`${colors.bg} ${colors.border} border-2 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto animate-slide-up`}>
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-full bg-white dark:bg-gray-800 shadow-md">
              {getIcon()}
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white">
                {title}
              </h2>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {type === 'configuration' ? 'Configuration requise' : 
                 type === 'route_unavailable' ? 'Service non disponible' :
                 type === 'carrier_not_configured' ? 'Transporteur non configuré' :
                 type === 'relay_carrier_not_configured' ? 'Point relais non configuré' :
                 type === 'warning' ? 'Attention requise' : 'Erreur détectée'}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className={`${colors.text} text-sm leading-relaxed whitespace-pre-line`}>
            {message}
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-6 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 rounded-b-2xl">
          <Button
            variant="outline"
            onClick={onClose}
            className="px-6"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            {type === 'route_unavailable' ? 'Changer le trajet' : 
             type === 'carrier_not_configured' ? 'Changer le transporteur' :
             type === 'relay_carrier_not_configured' ? 'Changer le point relais' :
             'Changer le type de service'}
          </Button>
          <Button
            onClick={onClose}
            className={`${colors.button} text-white px-6`}
          >
            Compris
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
